var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('IBModal',{staticClass:"modal-dropdown modal-history",nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('IBPaymentCardContent',_vm._b({staticClass:"d-block"},'IBPaymentCardContent',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }